import {
  Button,
  Col,
  Divider,
  Form,
  Modal,
  ModalProps,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  getDefaultConfigOfTable,
  syncDataDefaultConfig,
  updateTableConfigDefault,
} from "../../../api/table";
import { useMutation, useQuery } from "react-query";

import { CommonStatus } from "../../../constants/enum";
import CustomNotification from "Component/CustomNotification";
import ModalConfirm from "../ModalConfirm";
import _ from "lodash";
import classNames from "classnames";
import { handleErrorMessage } from "i18n";
import { queryClient } from "App";
import { queryKeys } from "../../../constants/constans";
import styles from "./styles.module.scss";
import useNetworkStatus from "hooks/useNetworkStatus";

interface IProps extends ModalProps {
  isVisible?: boolean;
  handleCancel: () => void;
}
// hime is people in table
const himeOptions = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
];

const pageRankingOptions = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
];

const durationOptions = [
  {
    value: 60,
    label: "60",
  },
  {
    value: 90,
    label: "90",
  },
  {
    value: 120,
    label: "120",
  },
];

const intervalTimeOptions = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
];

const timerOptions = Array.from({ length: 20 }, (_, index) => {
  return {
    value: index + 1,
    label: `${index + 1}`,
  };
});

const rankingRandomOptions = Array.from({ length: 20 }, (_, index) => {
  return {
    value: index + 1,
    label: `${index + 1}`,
  };
});

const ModalSettingDefault = (props: IProps) => {
  const { isVisible, handleCancel } = props;
  const [form] = Form.useForm();
  const isValidate = useRef<boolean>(false);
  const isOnline = useNetworkStatus();
  const mustSync = useRef<boolean>(false);
  const valueForm = useRef<any>({});

  const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);

  const syncDataDefaultConfigAction = useMutation(syncDataDefaultConfig);

  const { data: defaultConfig } = useQuery(
    queryKeys.defaultConfigTable,
    getDefaultConfigOfTable
  );

  const createTableConfig = useMutation(updateTableConfigDefault);

  useEffect(() => {
    if (defaultConfig?.data) {
      Object.keys(defaultConfig?.data).forEach((item) => {
        if (item === "tableCodeOptions" || item === "tableNoOptions") return;
        form.setFieldValue(item, String(defaultConfig?.data?.[`${item}`]));
      });
      form.setFieldsValue(defaultConfig?.data);
    }
  }, [defaultConfig, isVisible, form]);

  useEffect(() => {
    if (!!isOnline && mustSync.current) {
      const defaultConfigTable = queryClient.getQueryData(
        queryKeys.defaultConfigTable
      ) as any;
      syncDataDefaultConfigAction.mutate(
        _.pick(defaultConfigTable?.data, [
          "timer",
          "timerMin",
          "timerMax",
          "intervalTime",
          "intervalTimeMax",
          "intervalTimeMin",
          "courseTime",
          "hime",
          "showNextConfirm",
          "rankingRandom",
          "showEntropy",
        ])
      );
    }
  }, [isOnline]);

  const handleSubmitForm = (values: any) => {
    if (isValidate.current) {
      isValidate.current = false;
      return;
    }
    if (
      Number(values?.pageRanking) < Number(defaultConfig?.data?.pageRanking)
    ) {
      setShowModalConfirm(true);
      valueForm.current = values;
      return;
    }
    createTableConfig.mutate(values, {
      onError: (err) => {
        if (!!isOnline) {
          handleErrorMessage(err);
          return;
        }
        mustSync.current = true;
        queryClient.setQueryData(queryKeys.defaultConfigTable, {
          data: values,
        });
        CustomNotification({
          type: "success",
          description: "",
          message: "デフォルト値が設定されました。",
        });
        handleCancel();
      },
      onSuccess: (res) => {
        CustomNotification({
          type: "success",
          description: "",
          message: "デフォルト値が設定されました。",
        });
        queryClient.invalidateQueries(queryKeys.defaultConfigTable);
        queryClient.invalidateQueries(queryKeys.listHost);

        handleCancel();
      },
    });
  };

  const handleChangePage = () => {
    createTableConfig.mutate(valueForm.current, {
      onError: (err) => {
        if (!!isOnline) {
          handleErrorMessage(err);
          return;
        }
        mustSync.current = true;
        queryClient.setQueryData(queryKeys.defaultConfigTable, {
          data: valueForm.current,
        });
        CustomNotification({
          type: "success",
          description: "",
          message: "デフォルト値が設定されました。",
        });
        handleCancel();
      },
      onSuccess: (res) => {
        CustomNotification({
          type: "success",
          description: "",
          message: "デフォルト値が設定されました。",
        });
        setShowModalConfirm(false);
        queryClient.invalidateQueries(queryKeys.defaultConfigTable);
        queryClient.invalidateQueries(queryKeys.listHost);

        handleCancel();
      },
    });
  };

  const handleOnChangeForm = () => {
    isValidate.current = true;
    form.validateFields();
    form.submit();
  };
  return (
    <>
      <ModalConfirm
        title="削除されたスタッフページに設定されていたスタッフは出勤リストから削除されますがよろしいでしょうか？"
        handleCancel={() => setShowModalConfirm(false)}
        handleOke={handleChangePage}
        isVisible={showModalConfirm}
        closeIcon={false}
        textOke="はい"
        textCancel="いいえ"
      />
      {!showModalConfirm && (
        <Modal
          open={isVisible}
          footer={null}
          closable={false}
          className={styles.modalSettingDefault}
          width={700}
          centered
          destroyOnClose
        >
          <div className={styles.modalSettingContainer}>
            <div className={styles.header}>基本設定</div>
            <div className={styles.titleBody}>
              <span>卓設定のデフォルト値</span>
            </div>

            <div className={styles.formContainer}>
              <Form
                layout="horizontal"
                onFinish={handleSubmitForm}
                initialValues={defaultConfig?.data}
                validateTrigger="onSubmit"
                form={form}
              >
                <div className={styles.section}>
                  <div className={styles.titleGroup}>●コース時間</div>
                  <Row align="middle" justify="start">
                    <Form.Item name="courseTime" label="デフォルト値（分）">
                      <Select
                        className={classNames(styles.select, "select-default")}
                        options={durationOptions}
                        // defaultValue={durationOptions?.[0]?.value}
                      ></Select>
                    </Form.Item>
                  </Row>
                </div>
                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>●着席時間</div>
                  <Row className={styles.row}>
                    <Col sm={11}>
                      <Row align="middle" justify="start">
                        <Form.Item
                          name="timerMin"
                          label="着席時間の最小値（分）"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const timerMax = getFieldValue("timerMax");
                                if (timerMax && timerMax < value) {
                                  return Promise.reject(
                                    "最大値を最小値より大きい値を選択してください。"
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Select
                            className={classNames(
                              styles.select,
                              "select-default"
                            )}
                            options={timerOptions}
                            onChange={handleOnChangeForm}

                            // defaultValue={timerOptions?.[0]?.value}
                          ></Select>
                        </Form.Item>
                      </Row>
                    </Col>
                    <Col sm={11}>
                      <Row align="middle" justify="start">
                        <Form.Item
                          name="timerMax"
                          label="着席時間の最大値（分）"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const timerMin = getFieldValue("timerMin");
                                if (timerMin && timerMin > value) {
                                  return Promise.reject(
                                    "最大値を最小値より大きい値を選択してください。"
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Select
                            className={classNames(
                              styles.select,
                              "select-default"
                            )}
                            options={timerOptions}
                            onChange={handleOnChangeForm}

                            // defaultValue={
                            //   timerOptions[timerOptions.length - 1]?.value
                            // }
                          ></Select>
                        </Form.Item>
                      </Row>
                    </Col>
                  </Row>
                  <Row className={classNames("row-no-bottom")}>
                    <Col sm={11}>
                      <Row align="middle" justify="start">
                        <Form.Item
                          name="timer"
                          label="デフォルト値（分）"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const timerMin = getFieldValue("timerMin");
                                const timerMax = getFieldValue("timerMax");

                                if (
                                  timerMin &&
                                  timerMax &&
                                  (value > timerMax || value < timerMin)
                                ) {
                                  return Promise.reject("無効な値です。");
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Select
                            className={classNames(
                              styles.select,
                              "select-default"
                            )}
                            options={timerOptions}
                            onChange={handleOnChangeForm}

                            // defaultValue={
                            //   timerOptions[Math.floor(timerOptions.length / 2)]
                            //     ?.value
                            // }
                          ></Select>
                        </Form.Item>
                      </Row>
                    </Col>
                  </Row>
                </div>

                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>●ロスタイム</div>
                  <Row className={styles.row}>
                    <Col sm={11}>
                      <Row align="middle" justify="start">
                        <Form.Item
                          name="intervalTimeMin"
                          label="ロスタイムの最小値（分）"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const intervalTimeMax =
                                  getFieldValue("intervalTimeMax");
                                if (
                                  intervalTimeMax &&
                                  intervalTimeMax < value
                                ) {
                                  return Promise.reject(
                                    "最大値を最小値より大きい値を選択してください。"
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Select
                            className={classNames(
                              styles.select,
                              "select-default"
                            )}
                            options={intervalTimeOptions}
                            onChange={handleOnChangeForm}
                          ></Select>
                        </Form.Item>
                      </Row>
                    </Col>
                    <Col sm={11}>
                      <Row align="middle" justify="start">
                        <Form.Item
                          name="intervalTimeMax"
                          label="ロスタイムの最大値（分）"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const intervalTimeMin =
                                  getFieldValue("intervalTimeMin");
                                if (
                                  intervalTimeMin &&
                                  intervalTimeMin > value
                                ) {
                                  return Promise.reject(
                                    "最大値を最小値より大きい値を選択してください。"
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Select
                            className={classNames(
                              styles.select,
                              "select-default"
                            )}
                            options={intervalTimeOptions}
                            onChange={handleOnChangeForm}
                          ></Select>
                        </Form.Item>
                      </Row>
                    </Col>
                  </Row>
                  <Row className={classNames("row-no-bottom")}>
                    <Col sm={11}>
                      <Row align="middle" justify="start">
                        <Form.Item
                          name="intervalTime"
                          label="デフォルト値（分）"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const intervalTimeMin =
                                  getFieldValue("intervalTimeMin");
                                const intervalTimeMax =
                                  getFieldValue("intervalTimeMax");

                                if (
                                  intervalTimeMin &&
                                  intervalTimeMax &&
                                  (value > intervalTimeMax ||
                                    value < intervalTimeMin)
                                ) {
                                  return Promise.reject("無効な値です。");
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Select
                            className={classNames(
                              styles.select,
                              "select-default"
                            )}
                            options={intervalTimeOptions}
                            onChange={handleOnChangeForm}
                          ></Select>
                        </Form.Item>
                      </Row>
                    </Col>
                  </Row>
                </div>
                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>●来店人数</div>
                  <Row className={classNames("row-no-bottom")}>
                    <Col sm={11}>
                      <Row align="middle" justify="start">
                        <Form.Item name="hime" label="デフォルト値（人）">
                          <Select
                            className={classNames(
                              styles.select,
                              "select-default"
                            )}
                            options={himeOptions}
                          ></Select>
                        </Form.Item>
                      </Row>
                    </Col>
                  </Row>
                </div>

                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>
                    ●NEXTボタン実行の際、確認ポップアップの表示
                  </div>
                  <Form.Item name="showNextConfirm">
                    <Radio.Group>
                      <Radio value={CommonStatus.ACTIVE}>表示する</Radio>
                      <Radio value={CommonStatus.INACTIVE}>表示しない</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>
                    <p>●オートNEXTモード</p>
                    <span className={styles.textNote}>
                      カウントダウンタイマーが0になったら、自動的に次の枠に移動するモード
                    </span>
                  </div>
                  <Form.Item name="autoNextStep">
                    <Radio.Group>
                      <Radio value={CommonStatus.ACTIVE}>オン</Radio>
                      <Radio value={CommonStatus.INACTIVE}>オフ</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>
                    ●スタッフページのページ分割
                  </div>
                  <Form.Item name="pageRanking" label="ページの分割数">
                    <Select
                      className={classNames(styles.select, "select-default")}
                      options={pageRankingOptions}
                    ></Select>
                  </Form.Item>
                </div>
                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>
                    ●ランキングの登録可能数
                  </div>
                  <Form.Item name="rankingRandom" label="ページの分割数">
                    <Select
                      className={classNames(styles.select, "select-default")}
                      options={rankingRandomOptions}
                    ></Select>
                  </Form.Item>
                </div>
                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>
                    ●男女差カウンターの表示
                  </div>
                  <Form.Item name="showEntropy">
                    <Radio.Group>
                      <Radio value={CommonStatus.ACTIVE}>表示する</Radio>
                      <Radio value={CommonStatus.INACTIVE}>表示しない</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>
                    <p>●エントリーモード</p>
                    <span className={styles.textNote}>
                      立候補した人のみを接客させる付け回し方式に対応するモード
                    </span>
                  </div>
                  <Form.Item name="autoCandidacy">
                    <Radio.Group>
                      <Radio value={CommonStatus.ACTIVE}>オン</Radio>
                      <Radio value={CommonStatus.INACTIVE}>オフ</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>
                    ●卓設定時の開始時間
                    <span className={styles.textNote}>
                      「設定する」時に開始時間として現在時刻に加算する分数
                    </span>
                  </div>
                  <Form.Item
                    name="startTimeOffsetMinutes"
                    label="現在時刻 + （分）"
                  >
                    <Select
                      className={classNames(styles.select, "select-default")}
                      options={Array.from({ length: 31 }, (_, i) => ({
                        value: i,
                        label: `${i}`,
                      }))}
                    />
                  </Form.Item>
                </div>
                <Divider />
                <div className={styles.section}>
                  <div className={styles.titleGroup}>
                    ●卓番号の選択肢
                    <span className={styles.textNote}>
                      卓設定画面の卓番号リストに表示する値（Enterで追加・×で削除）
                    </span>
                  </div>
                  <Form.Item
                    name="tableCodeOptions"
                    label="記号（アルファベット等）"
                  >
                    <Select
                      mode="tags"
                      className={classNames(styles.select, "select-default")}
                      tokenSeparators={[","]}
                      placeholder="A, B, C ..."
                    />
                  </Form.Item>
                  <Form.Item name="tableNoOptions" label="番号">
                    <Select
                      mode="tags"
                      className={classNames(styles.select, "select-default")}
                      tokenSeparators={[","]}
                      placeholder="1, 2, 3 ..."
                    />
                  </Form.Item>
                </div>
                <Divider />

                <div className={styles.btnContainer}>
                  <Button
                    className={classNames(styles.btn, "btn-default")}
                    htmlType="submit"
                    disabled={createTableConfig.isLoading}
                  >
                    {!createTableConfig.isLoading ? (
                      "保存する"
                    ) : (
                      <Spin spinning={true} />
                    )}
                  </Button>
                  <Button
                    className={classNames(styles.btn, "btn-default")}
                    onClick={handleCancel}
                  >
                    キャンセル
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
export default ModalSettingDefault;
